import { render, staticRenderFns } from "./FertilizerDefaultList.vue?vue&type=template&id=b0923c3e&scoped=true&"
import script from "./FertilizerDefaultList.vue?vue&type=script&lang=js&"
export * from "./FertilizerDefaultList.vue?vue&type=script&lang=js&"
import style0 from "./FertilizerDefaultList.vue?vue&type=style&index=0&id=b0923c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0923c3e",
  null
  
)

export default component.exports